import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";

import { uuidGenerator } from "./index";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const parseDirections = directions =>
  directions.length
    ? directions
        .split(/\r|\n/)
        .filter(x => x.length)
        .map(line => {
          const [text, miles] = line.split(/\s+(?=(\d+(\.\d+)?\sMILES))/);

          return {
            id: uuidGenerator(),
            text: text || "",
            miles: parseFloat(miles) || 0
          };
        })
    : [{ miles: 0 }];

export const getFormattedDirection = (
  { OriginLocation, DestinationLocation, Priority, SpecInstr, Directions },
  lastItem = false
) => {
  const totalMiles = Directions.reduce((acc, curr) => acc + curr.miles, 0);

  const directions = [
    ...Directions,
    { id: "totalMiles", text: "Total Mileage", miles: totalMiles }
  ];
  const content = [
    `PRIORITY: ${Priority}`,
    {
      layout: "noBorders",
      table: {
        widths: [100, "*", "auto"],
        body: [
          [
            "FROM",
            [OriginLocation.LocationName, OriginLocation.LocationID]
              .filter(Boolean)
              .join(" - "),

            `${OriginLocation.City}, ${OriginLocation.State}`
          ],
          [
            "TO",
            [DestinationLocation.LocationName, DestinationLocation.LocationID]
              .filter(Boolean)
              .join(" - "),
            `${DestinationLocation.City}, ${DestinationLocation.State}`
          ]
        ]
      }
    },
    "\n\n",
    {
      layout: "lightHorizontalLines",
      table: {
        headerRows: 1,
        widths: ["*", 50],
        body: [
          [
            {
              text: "DIRECTIONS",
              bold: true
            },
            {
              text: "MILES",
              alignment: "right",
              bold: true
            }
          ],
          ...directions.map(({ text, miles }) => [
            { text, lineHeight: 1.6 },
            {
              text: parseFloat(miles).toFixed(1),
              alignment: "right",
              lineHeight: 1.6
            }
          ])
        ]
      }
    }
  ];

  if (SpecInstr) {
    content.push(
      "\n\n",
      { text: "SPECIAL INSTRUCTIONS", style: { bold: true, fontSize: 14 } },
      {
        text: SpecInstr
      }
    );
  }
  content[content.length - 1] = lastItem
    ? content[content.length - 1]
    : { ...content[content.length - 1], pageBreak: "after" };
  return content;
};

export const getFormattedInspection = (Inspections, MainInfo) => {
  const content = [
    `${MainInfo}`,
    {
      layout: "noBorders",
      table: {
        widths: [100, "*", "auto"],
        body: [["Date", moment(new Date()).format("MM/DD/YYYY")]]
      }
    },
    "\n\n",
    {
      layout: "lightHorizontalLines",
      table: {
        headerRows: 1,
        widths: ["*", 50],
        body: [
          [
            {
              text: "Description",
              bold: true
            },
            {
              text: "Line #",
              alignment: "right",
              bold: true
            }
          ],
          ...Inspections.map(({ LineItem, Description }) => [
            { text: Description, lineHeight: 1.6 },
            {
              text: parseFloat(LineItem),
              alignment: "right",
              lineHeight: 1.6
            }
          ])
        ]
      }
    }
  ];
  return content;
};

export const printDirections = (...Directions) => {
  try {
    const docDef = {
      content: Directions.map((d, i, arr) =>
        getFormattedDirection(
          { ...d, Directions: parseDirections(d.Directions) },
          i === arr.length - 1
        )
      )
    };
    pdfMake.createPdf(docDef).print();
  } catch (err) {
    console.log(err);
  }
};

export const printInspections = (Inspections, MainInfo) => {
  try {
    const docDef = {
      content: Inspections.map(i => getFormattedInspection(i, MainInfo))
    };
    pdfMake.createPdf(docDef).print();
  } catch (err) {
    console.log(err);
  }
};
